<template>
  <div class="login-component">
    <div :class="['login-row', { error: nameError }]">
      <input
        type="text"
        class="login-input"
        v-model.trim="userName"
        :placeholder="T('Email')"
        @keydown.enter="$refs.password.focus()"
      />
    </div>
    <div :class="['login-row', { error: passError }]">
      <input
        ref="password"
        type="password"
        class="login-input"
        v-model.trim="password"
        :placeholder="T('Password')"
        @keydown.enter="validateLogin"
      />
    </div>
    <p class="error-text" v-if="errorText">{{ errorText }}</p>
    <div class="login-btn" @click="validateLogin">{{T('Login')}}</div>
  </div>
</template>

<script>
import { login } from "@js/api";
export default {
  data() {
    return {
      userName: "",
      password: "",
      nameError: false,
      passError: false,
      errorText: "",
    };
  },
  methods: {
    async validateLogin() {
      if (!this.userName) {
        this.nameError = true
      } else {
        this.nameError = false
      }
      if (!this.password) {
        this.passError = true
      } else {
        this.passError = false
      }
      if (this.passError || this.nameError) {
        return
      }
      let data = await login({
        username: this.userName,
        password: this.password,
      })
      if (data.status == 1) {
          // location.reload()
          // this.$store.dispatch('upDateLogin')
          this.$emit('login')
      } else {
          this.errorText = this.T('Error')
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.login-component {
  display: inline-block;
  width: 100%;

  .login-row {
    width: 100%;
    height: 0.7rem;
    margin: 0.3rem 0;
    background-color: #5a88c4;
    box-shadow: 0 2px 0 0 #71a0cc;
    border: solid 0.02rem #436c9b;
      
    &.error {
        border-color: #c45;
        box-shadow: 0 2px 5px #c45;

        input {
          color: #c45;
        }
        ::-webkit-input-placeholder {
            color: #c45;
        }
    }


    .login-input {
      width: 100%;
      height: 100%;
      padding-left: 0.15rem;
      color: #d0e3f4;
      font-size: 0.3rem;
      background-color: rgba(0, 0, 0, 0);
      border: none;
    }
  }

  .error-text {
      margin-top: -.2rem;
      text-align: center;
      color: #c45;
  }

  .login-btn {
    @extend .common-btn;
    margin: 0 auto;
  }
}
</style>